import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { LoadingPlaceholderIcon } from '@liveoptics/react-ui';

const Placeholder = styled.div`
  display: flex;
  height: calc(100vh - 4.3rem);
  width: auto;
  background-color: #f5f6fb;
  align-items: center;
  justify-content: center;
`;


const LoadingView: FC = () => {
  return <Placeholder><LoadingPlaceholderIcon colored={false} /></Placeholder>;
};

export default LoadingView;

